<template>
  <img id="image-loading" class="vessel-image" :src="image" :text="avatarText">
</template>

<script>
  // モジュール
  import {storage} from "@/firebase/firebaseConfig";

  export default {
    name: "FirebaseStoragePicture",
    components: {},
    props: {
      picture: {
        type: Object
      }
    },
    data() {
      return {
        image: null,
        avatarText: "",
      }
    },
    computed: {},
    beforeDestroy() {
      this.reset();
    },
    mounted() {
      this.reset();
      this.loadPicture();
    },
    methods: {
      reset() {
        this.image = null;
        this.avatarText = null;
      },
      getPicture() {
        return storage
          .child(this.picture.thumbnail_path)
          .getDownloadURL()
          .then(response => {
            this.image = response;
          });
      },
      retryLoadPicture() {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve(this.getPicture());
          }, 500);
        })
        .then(() => {
          // Loading close
          this.$vs.loading.close('#image-loading > .con-vs-loading');
        })
      },
      loadPicture() {

        // Loading start
        this.$vs.loading({
          container: '#image-loading',
          scale: 0.6
        });

        this.retryLoadPicture()
          .catch(this.retryLoadPicture())
          .catch(this.retryLoadPicture())
          .catch(this.retryLoadPicture());
      },
    }
  }

</script>

<style lang="sass">

</style>
